module.exports = __webpack_public_path__ + "img/basic_shader_scroller.28a437e2.gif";